import React, {useState,useEffect,useRef,CSSProperties} from "react";
import Select from "react-select";
import ImageWithBasePath from '../../core/img'
import Slider from 'react-slick'
import {Link,useNavigate} from 'react-router-dom';
import FormNoData from '../formNoData';
import {all_routes} from '../router/all_routes';
import {Toaster} from 'react-hot-toast';
// -- biz9 --
import SubValue from "../subValue";
import {Portal_Type,Portal_Field,Portal_Table,Portal_Stat,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Page,Portal_Remote_Data,Sub_Value_Type} from "biz9-portal-app";
import {Message,Field,Title,Config} from "../../constant";
import {Image,Field_Logic,Style,Toast_Message,Storage,User,App,Data} from "../../project";
import {Favorite_Logic,Favorite_Table,Favorite_Url,Favorite_Field,Favorite_Service} from "biz9-favorite";
import {Image_Type} from "biz9-image";
import {Log,Num,Str,DateTime,Obj,Status_Type,Response_Logic} from "biz9-utility";
import {Data_Logic} from "biz9-data-app";
import {Review_Table,Review_Field,Review_Stat} from "biz9-review";
import {UrlQuery} from "biz9-react-utility";

const Product_App = () => {
    /* -- DEFINE -- *
     * 9_define
     * --- BUTTONZ ---
     * btn_post_search_filter - run search.
     * btn_reset_filter - ?
     * btn_sort_filter - sort-search-items, low-high-most-popular
     *
     */
    const query = UrlQuery();
    const routes = all_routes;
    // -- page-edit --
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
    const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
    const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:10,show_value:false}));
    const [edit_mode,setEditMode] = useState(false);
    const [user,setUser] = useState(User.get());
    const [showMoreCategories, setShowMoreCategories] = useState(false);
    const [showMoreLocation, setshowMoreLocation] = useState(false);
    const [categorys, setCategorys] = useState([]);
    //const [products, setProducts] = useState(Data_Logic.get(Portal_Table.PRODUCT,0,{data:{test:true,count:3,blank:true}}));
    const [products, setProducts] = useState([]);
    const [types, setApplicationTypes] = useState([]);
    const [filter_check_types, setFilterCheckApplicationTypes] = useState({});
    const [filter_check_categorys, setFilterCheckCategorys] = useState({});
    const [val_filter_check_budget, setValFilterCheckBudget] = useState(9999);
    const [val_search, setValSearch] = useState('');
    const [stop_search, setStopSearch] = useState('');
    const [search_filter, setSearchFilter] = useState({});
    const [sort_filter, setSortFilter] = useState({});
    const [val_search_page_current, setValSearchPageCurrent] = useState(1);
    const [val_search_page_count, setValSearchPageCount] = useState(1);
    const [val_search_page_size, setValSearchPageSize] = useState(30);
    const [val_search_item_count, setValSearchItemCount] = useState(99);
    const [val_header_title, setValHeaderTitle] = useState('Search AppZ');
    const [val_header_sub_title, setValHeaderSubTitle] = useState("");

    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            clear_products();
            get_page_data();
            }, [page.id]);
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_data();
            }, []);
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_products_data();
            }, []);
    async function get_page_data() {
        // -- get-page-remote-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.PRODUCT_HOME.title_url,option);
        bind_page(data);
    };
    async function get_data() {
        // -- get-data-remote-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get_product_home_items(App.get_url(Portal_Page.PRODUCT_HOME[Portal_Type.ITEMS_URL]),null,option);
        bind_items(data);
        Toast_Message.dismiss();
    }
    async function get_products_data() {
        //  -- get-search-products --
        let response = Response_Logic.get();
        let data = {};
        let search = Data_Logic.get_search(Portal_Table.PRODUCT,{},{sort_by:{data_create:-1},page_current:1, page_size:50});
        let value = null;
        let type = null;
        // -- category --
        if(!Str.check_is_null(query.get(Field.CATEGORY))){
            let category = query.get(Field.CATEGORY);
            let check_box = {};
            check_box[category]=true;
            setFilterCheckCategorys(check_box);
            search.filter = {category:category};
        }
        // -- keyword --
        // db.collection.find({ fieldName: { $regex: "myValue", $options: "i" } })
        if(!Str.check_is_null(query.get(Field.KEYWORD))){
            value = Str.get_regex_pipe(query.get(Field.KEYWORD));
            setValSearch(query.get(Field.KEYWORD));
            let val_or_filter =  [
            { title: { $regex:value, $options: "i" } },
            { tags: { $regex:value, $options: "i" } },
            { note: { $regex:value, $options: "i" } }
            ];
            search.filter = {$or:val_or_filter};
        }
        // -- type --
        if(!Str.check_is_null(query.get(Field.TYPE)) ){
            if(query.get(Field.TYPE) != Field.ANY){
                type = query.get(Field.TYPE);
                switch(type){
                    case Title.PRODUCT_APP_TYPE_MOBILE:
                        setFilterCheckApplicationTypes({"Mobile":true});
                        break;
                    case Title.PRODUCT_APP_TYPE_WEBSITE:
                        setFilterCheckApplicationTypes({"Website":true});
                        break;
                    case Title.PRODUCT_APP_TYPE_LANDING_PAGE:
                        setFilterCheckApplicationTypes({"Landing Page":true});
                        break;
                }
                if(search.filter.$or){
                    if(search.filter.$or.length>0){
                        search.filter = {$or:search.filter.$or,$and:[{type:type}] };
                    }
                }else{
                    search.filter = {type:type};
                }
            }
        }
        let option = {get_cache:false,time_limit:10};
        const [biz_response,biz_data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        bind_products(Obj.get_random_items(biz_data.items,biz_data.items.length));
        Toast_Message.dismiss();
    };
    async function bind_page(data) {
        // -- page --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
    };
    async function bind_items(data) {
        setApplicationTypes(data[Portal_Type.TYPES]);
        setCategorys(data[Portal_Type.CATEGORYS]);
    }
    async function bind_products(data) {
        setProducts(data);
    }
    async function bind_sub_values(data_sub_group) {
        // -- bind-sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
    async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                        ...sub_value_group,
                        [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                        ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                        value: sub_value.value
                        }
                        }));
        }else{
            setSubValueGroup(sub_value_group => ({
                        ...sub_value_group,
                        [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                        ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                        items: sub_value.items
                        }
                        }));
        }
    }
    const run_search = (e) => {
        // -- run-search --
        const value = e.target.value;
        setValSearch(value);
    };
    const sort_by_type = [
        { value: "cost_desc", label: "Price: Low to High" },
        { value: "cost_asc", label: "Price: High to Low" },
        { value: "popular", label: "Most Popular" },
        { value: "new", label: "Newest" },
        { value: "old", label: "Oldest" },
    ];
    const update_search_application_type_filter = (event) => {
        const { id, checked } = event.target;
        setFilterCheckApplicationTypes({});
        setFilterCheckApplicationTypes(prevState => ({
                    ...prevState,
                    [id]: checked,
                    }));
    };
    const update_search_category_filter = (event) => {
        const { id, checked } = event.target;
        setFilterCheckCategorys(prevState => ({
                    ...prevState,
                    [id]: checked,
                    }));
    };
    const update_search_budget_filter = (event) => {
        setValFilterCheckBudget(event.target.id);
    };
    const get_search_budget_filter = (val) => {
        switch(val){
            case 'budget_check_any':
                return { $expr: { $lte: [ { $toInt: "$cost" }, 99999 ] } }
                break;
            case 'budget_check_1':
                return { $expr: {
                    $and: [
                    { $gt: [ { $toInt: "cost" }, 0 ] },
                    { $lt: [ { $toInt: "cost" }, 749 ] }
                    ]
                }}
                break;
            case 'budget_check_2':
                return { $expr: {
                    $and: [
                    { $gt: [ { $toInt: "$cost" }, 749 ] },
                    { $lt: [ { $toInt: "$cost" }, 2499 ] }
                    ]
                }}
                break;
            case 'budget_check_3':
                return { $expr: {
                    $and: [
                    { $gt: [ { $toInt: "$cost" }, 2499 ] },
                    { $lt: [ { $toInt: "$cost" }, 99999 ] }
                    ]
                }}
                break;
            default:
                return { $expr: { $lte: [ { $toInt: "$cost" }, 99999 ] } }
                break;
        }
    }
    const search_category_filter = (title) => {
        clear_products();
        //let search = Data_Logic.get_search(Portal_Table.PRODUCT,{category:title}},{date_create:-1},1,val_search_page_size);
        //search_data(search);
    let check_box = {};
    check_box[title]=true;
    setFilterCheckCategorys(check_box);
}
const btn_reset_filter = (event) => {
    event.preventDefault();
    clear_products();
    setFilterCheckCategorys({});
    setFilterCheckApplicationTypes({});
    let search = Data_Logic.get_search(Portal_Table.PRODUCT,{},{date_create:-1},1,val_search_page_size);
    setValSearch('');
    search_data(search);

    /*
       setFilterCheckApplicationTypes({"Mobile":true});
       let search = Data_Logic.get_search(Portal_Table.PRODUCT,{},{date_create:-1},1,val_search_page_size);
       setValSearch('');
       search_data(search);
       */
}
const clear_products = () => {
    setProducts([]);
}
const btn_go_to_page = (page_current: any) => {
    setValSearchPageCurrent(page_current);
    clear_products();
    let search = Data_Logic.get_search(Portal_Table.PRODUCT,search_filter,{sort_by:sort_filter,page_current:page_current,page_size:val_search_page_size});
    search_data(search);
}
async function search_data(search) {
    Toast_Message.loading(Message.SEARCHING);
    let option = {};
    const [biz_response,biz_data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
    //set_page_sub_title(search.page_current,data.product_page_count);
    setSearchFilter(search.filter);
    setSortFilter(search.sort_by);
    setValSearchPageCount(biz_data.page_count);
    setProducts(biz_data[Sub_Value_Type.ITEMS]);
    setValSearchItemCount(biz_data.item_count);
    Toast_Message.dismiss();
}
const set_page_sub_title = (page_current,page_count) => {
    if(Str.check_is_null(page_count)){
        page_count = 1;
    }
    if(Str.check_is_null(page_current)){
        page_current = 1;
    }
    setValHeaderSubTitle("Showing Page "+page_current+" of "+page_count);
}
const btn_post_search_filter = (event) => {
    event.preventDefault();
    post_search();
}
const post_search = () => {
    Toast_Message.loading(Message.SEARCHING);
    clear_products();
    let has_type = true;
    let has_category = false;
    let has_search = false;
    let has_budget = false;
    let run_search = false;
    let reg_val = '';
    if(val_search){
        has_search = true;
        reg_val = Str.get_regex_pipe(val_search);
    }
    for(let a = 0; a<categorys.length;a++){
        if(filter_check_categorys[categorys[a].title]==true){
            has_category = true;
        }
    }
    let filter =  has_category || has_search ? {$or:[], $and:[]} : {$and:[]};
    for(let a = 0; a<types.length;a++){
        if(filter_check_types[types[a].title] == true){
            filter.$and.push( { type:types[a].title } );
        }
    }
    if(has_search && has_category && !run_search){
        run_search = true;
        filter.$or.push(
                { title:{ $regex:reg_val, $options: "i" } },
                { tags: { $regex:reg_val, $options: "i" } },
                { note: { $regex:reg_val, $options: "i" } }
                );
        for(let a = 0; a<categorys.length;a++){
            if(filter_check_categorys[categorys[a].title] == true){
                filter.$or.push({category:categorys[a].title});
            }
        }
    }
    else if(has_search && has_category && !run_search){
        run_search = true;
        filter.$or.push(
                { title: { $regex:reg_val, $options: "i" } },
                { tags: { $regex:reg_val, $options: "i" } },
                { note: { $regex:reg_val, $options: "i" } }
                );
        for(let a = 0; a<categorys.length;a++){
            if(filter_check_categorys[categorys[a].title] == true){
                filter.$or.push({category:categorys[a].title});
            }
        }
    }
    else if(has_search && !run_search){
        run_search = true;
        filter.$or.push(
                { title: { $regex:reg_val, $options: "i" } },
                { tags: { $regex:reg_val, $options: "i" } },
                { note: { $regex:reg_val, $options: "i" } }
                );
    }
    else if(has_category && !run_search){
        run_search = true;
        for(let a = 0; a<categorys.length;a++){
            if(filter_check_categorys[categorys[a].title] == true){
                filter.$or.push({category:categorys[a].title});
            }
        }
    }
    else if(has_category && !run_search){
        for(let a = 0; a<categorys.length;a++){
            if(filter_check_categorys[categorys[a].title] == true){
                filter.$or.push({category:categorys[a].title});
            }
        }
    }
    //budget
    filter.$and.push( get_search_budget_filter(val_filter_check_budget) );
    let search = Data_Logic.get_search(Portal_Table.PRODUCT,filter,{sort_by:{date_create:-1},page_current:1,page_size:val_search_page_size});
    Log.w('22_RUN_SEARCH',search);
    search_data(search);
};
async function btn_post_favorite(is_favorite,id) {
    /*
       let favorite = Favorite_Logic.get(Data_Logic.get(Portal_Table.PRODUCT,id);
       if(!user.is_guest){
       if(!is_favorite){
       let [response,data] = await Favorite_Service.post(App.get_url(Favorite_Url.POST),favorite);
       }else{
       let [response,data] = await Favorite_Service.post(App.get_url(Favorite_Url.DELETE),favorite);
       }
       setProducts(products.map(item =>
       item.id === id ? { ...item, is_favorite: !item.is_favorite } : item
       ));
       }
       */

};
const slideslideroption = {
dots: true,
      nav: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      draggable:true,
      tochMove:true,
      swipe:true,
      slidesToScroll: 1,
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 3,
            },
      },
      {
breakpoint: 700,
            settings: {
slidesToShow: 2,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
const toggleMoreCategories = () => {
    setShowMoreCategories((prevShow) => !prevShow);
};
const toggleMoreLocation = () => {
    setshowMoreLocation((prevShow) => !prevShow);
};
const serviceslideroption = {
dots: false,
      nav: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      draggable:true,
      tochMove:true,
      swipe:true,
      slidesToScroll: 1,
      responsive: [
      {
breakpoint: 1000,
            settings: {
slidesToShow: 3,
            },
      },
      {
breakpoint: 700,
            settings: {
slidesToShow: 2,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
};
const [selectedItems, setSelectedItems] = useState(Array(10).fill(false));
const handleItemClick = (index: number) => {
    setSelectedItems((prevSelectedItems) => {
            const updatedSelectedItems = [...prevSelectedItems];
            updatedSelectedItems[index] = !updatedSelectedItems[index];
            return updatedSelectedItems;
            });
};
type SectionState = {
sortBy: boolean;
};
const [activeSections, setActiveSections] = useState<SectionState>({
sortBy: false,
});

const toggleSection = (section: keyof SectionState) => {
    setActiveSections((prevState) => {
            const newState: SectionState = {
sortBy: false,
};
return {
...newState,
[section]: !prevState[section],
};
});
};
const btn_sort_filter = (event) => {
    const sort_by = {};
    clear_products();
    setSortFilter(event.value);
    switch(event.value)
    {
        case "cost_desc":
            sort_by["cost"] = 1;
            break;
        case "cost_asc":
            sort_by["cost"] = -1;
            break;
        case "new":
            sort_by["date_create"] = 1;
            break;
        case "old":
            sort_by["date_create"] = -1;
            break;
        case "popular":
            sort_by["post_view"] = -1;
            break;
    }
    let search = Data_Logic.get_search(Portal_Table.PRODUCT,search_filter,{sort_by:sort_by,page_current:val_search_page_current,page_size:val_search_page_size});
    search_data(search);
};
return (
        <>
        <Toaster />
        <div className="breadcrumb-bar breadcrumb-bar-info">
        <div className="breadcrumb-img">
        <div className="breadcrumb-left">
        <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="img" />
        </div>
        </div>

        <div className="container">
        <div className="row">
        <div className="col-md-12 col-12">
        <nav aria-label="breadcrumb" className="page-breadcrumb">
        <ol className="breadcrumb">
        <li className="breadcrumb-item">
        <Link to={all_routes.home}>Home</Link>
        </li>
        <li className="breadcrumb-item" aria-current="page">
        Search
        </li>
</ol>
</nav>

<h2 className="breadcrumb-title mb-0">

{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,1):""}
<span style={{ marginRight: '10px' }} >{sub_value_group.sub_value_1.value}</span>{" "}
<span className="text-primary">
</span>
<span className="text-primary">
{edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,2):""}
<span className="mr-40">{sub_value_group.sub_value_2.value}
</span>


</span>
</h2>
</div>
</div>
</div>
</div>
{/* /Breadcrumb */}
{/* Page Content */}
<div className="page-content">
<div className="container">
{/* Title */}
<div className="title-section">
<div className="row align-items-center">
<div className="col-lg-6">
<div className="title-header">
<h3>{val_header_title}</h3>
<p>{val_header_sub_title}</p>
</div>
</div>

<div className="col-lg-6">
{/* Sort By */}
<div className="filters-wrap sort-categories justify-content-lg-end">
<div className={`collapse-card ${
    activeSections.sortBy ? "active" : ""
}`}
>

<div className="filter-header">
<Select
options={sort_by_type}
className="select serviceselect"
styles={Style.customStyles}
defaultValue={sort_by_type[0]}
classNamePrefix="react-select"
onChange={btn_sort_filter}
/>

</div>
</div>
</div>
{/* /Sort By */}
</div>
</div>
</div>
{/* /Title */}
{/* Search Details */}
<div className="service-gigs">
<div className="row">
{/* Sidebar */}
<div className="col-lg-3">
<div className="theiaStickySidebar">
<div className="sidebar-widget">
<div className="sidebar-header">
<h3>Filter</h3>
<Link onClick={(e) => {btn_reset_filter(e)}} to="#" className="reset-link">
Reset
</Link>
</div>
<div className="sidebar-body p-0">

<div className="collapse-card">
<div className="form-group search-group">
<span className="search-icon">
<i className="feather icon-search" />
</span>
<input
type="text"
className="form-control"
placeholder="Search"
value={val_search}
onChange={run_search}
/>
</div>


{/* Mobile-Type-Start */}
<h4 className="card-title">
<Link className="" data-bs-toggle="collapse" to="#apptype" aria-expanded="true">
<ImageWithBasePath src="/assets/img/icons/category-icon.svg" alt="icon" />
{Title.LABEL_APPLICATION_TYPE}
</Link>
</h4>
<div id="apptype" className="collapse show">
<div className="collapse-body">

<ul className="checkbox-list">
{types.map((item) => (
            <li key={item.id}>
            <label className="custom_check">
            <input id={item.title} value={item.title} checked={filter_check_types[item.title] || false} onChange={update_search_application_type_filter} type="checkbox" />
            <span className="checkmark" />
            <span className="checked-title">
            {item.title + " ("+item[Portal_Type.COUNT]  + ")"}
            </span>
            </label>
            </li>
            ))}
</ul>
</div>
</div>
{/* Mobile-Type-End */}
<h4 className="card-title">
<Link className="" data-bs-toggle="collapse" to="#categories" aria-expanded="true">
<ImageWithBasePath src="/assets/img/icons/category-icon.svg" alt="icon" />
Categories
</Link>
</h4>
<div id="categories" className="collapse show">
<div className="collapse-body">
<ul className="checkbox-list">

{categorys.map((item) => (
            <li key={item.id}>
            <label className="custom_check">
            <input id={item.title} value={item.title}  checked={filter_check_categorys[item.title] || false}  onChange={update_search_category_filter} type="checkbox" />
            <span className="checkmark" />
            <span className="checked-title">
            {item.title + " ("+item[Portal_Type.COUNT] + ")"}
            </span>
            </label>
            </li>
            ))}


</ul>
</div>
</div>

{/* Categories-end */}


</div>
{/* /Categories */}

{/* Budget */}
<div className="collapse-card">
<h4 className="card-title">
<Link
className=""
data-bs-toggle="collapse"
to="#budget"
aria-expanded="true"
>
<ImageWithBasePath src="/assets/img/icons/money-icon.svg" alt="icon" />
Budget
</Link>
</h4>

<div id="budget" className="collapse show">
<div className="collapse-body">

<ul className="checkbox-list">

<li>
<label className="custom_radio">
<input defaultChecked id="budget_check_any" value="9999" type="radio" name="budget_filter"  onChange={update_search_budget_filter} />
<span className="checkmark" />
<span className="text-dark"> Any </span>
</label>
</li>
<li>
<label className="custom_radio">
<input id="budget_check_1" value="500" type="radio" name="budget_filter"  onChange={update_search_budget_filter}  />
<span className="checkmark" />
<span className="text-dark"> Value :</span> Under
$750
</label>
</li>

<li>
<label className="custom_radio">
<input id="budget_check_2" value="1500" type="radio" name="budget_filter"  onChange={update_search_budget_filter}  />
<span className="checkmark" />
<span className="text-dark"> Mid-range :</span>{" "}
$750 - $2,500
</label>
</li>

<li>
<label className="custom_radio">
<input id="budget_check_3" value="2500" type="radio" name="budget_filter"  onChange={update_search_budget_filter}  />
<span className="checkmark" />
<span className="text-dark"> High-end :</span>
$2,500 - up
</label>
</li>

</ul>
</div>
</div>
</div>
{/* /Budget */}
</div>
<Link onClick={(e) => btn_post_search_filter(e)} to="#" className="btn btn-primary w-100">
<i className="fa-solid fa-caret-right" />
Filter
</Link>
</div>
</div>
</div>
{/* /Sidebar */}
<div className="col-lg-9">
<div className="row">
{/* Services */}
{products.length<=0 && <FormNoData/>}
{products.map((item) => (
            <div className="col-xl-4 col-md-6">
            <div className="gigs-grid">
            <div className="gigs-img">
            <div className="img-slider">
            <div className="slide-images">
            <Link to={"/app/"+item.title_url}>
            <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Type.ORIGINAL)} className="img-fluid" alt="img" /> </Link>
            </div>
            </div>
            <div className="card-overlay-badge">
            {item.featured == "true" && (
                    <Link to="#">
                    <span className="badge bg-warning">
                    <i className="feather icon-star" />
                    Featured
                    </span>
                    </Link>
                    )}
            {item.hot == "true" && (
                    <Link to="#">
                    <span className="badge bg-danger">
                    <i className="fa-solid fa-meteor" />
                    Hot
                    </span>
                    </Link>
                    )}
            </div>
                <div className="fav-selection"  key={1}  onClick={() => handleItemClick(1)}>
                <Link key={item.id} to="#" className={item.is_favorite ? 'fav-icon favourite' : 'fav-icon'} onClick={() => btn_post_favorite(item.is_favorite,item.id)} >
                <i className="feather icon-heart" />
                </Link>
                </div>
                </div>
                <div className="gigs-content">
                <div className="gigs-info">
                <Link to={"#"} className="badge bg-primary-light" >
                {item.category}
            </Link>
                <div className="star-rate">
                <span>
                {Array.from({ length: parseInt(item[Review_Field.REVIEW_RATING_AVG]) }).map((_, index) => (
                            <i className="fa-solid fa-star" />
                            ))}

            </span>
                </div>
                </div>
                <div className="gigs-title">
                <h3>
                <Link to={"/app/"+item.title_url}>
                {item.title}
            </Link>
                </h3>
                </div>

                <div className="gigs-card-footer">
                <h5>{Str.get_money(item.cost)}</h5>
                <span className="badge">{item.delivery_time}</span>
                </div>
                </div>
                </div>
                </div>
                ))}

{/* /Services */}

<div className="col-md-12">
{/* Pagination */}
{products.length>0 && (
        <div className="pagination">
        <ul>
        {val_search_page_current > 1 && (
                <li>
                <Link onClick={(e) => { btn_go_to_page(val_search_page_current-1) }} to="#" className="previous">
                <i className="fa-solid fa-chevron-left" />
                </Link>
                </li>
                )}
        {Array.from({ length: val_search_page_count }).map((_, index) => (
                    <li>
                    <Link  onClick={(e) => { btn_go_to_page(index+1) }} to="#" className={val_search_page_current == index+1 ? "active" : "" }>
                    {index+1}
                    </Link>
                    </li>
                    ))}

        {val_search_page_current < val_search_page_count && (

                <li>
                <Link  onClick={(e) => { btn_go_to_page(val_search_page_current+1) }} to="#" className="next">
                <i className="fa-solid fa-chevron-right" />
                </Link>
                </li>
                )}

        </ul>
            </div>
            )}


{/* /Pagination */}

</div>
</div>
</div>
</div>
</div>
{/* /Service Details */}
</div>
</div>
{/* /Page Content */}
<SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />
</>
)
}

export default Product_App
